import Backbone from 'backbone';

const obstacle = Backbone.Model.extend({
  name() {
    return this.get('name');
  },

  level() {
    return this.get('level');
  },

  conditionals() {
    return this.get('conditionals');
  },

  description() {
    return this.get('description');
  }
});

export default obstacle;
